import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _keys from 'lodash/keys';
import { classNames } from '../../../../utils/classname';
export function getParentPath(path) {
  return path.slice(0, -1).join('.');
}
export function isArrayParent(item, path) {
  var parentPath = getParentPath(path);
  return _isArray(_get(item, parentPath));
}
export function addToGroup(itemGroups, groupValue, description, item, defaultGroupName) {
  var key = groupValue || defaultGroupName;
  return _objectSpread(_objectSpread({}, itemGroups), {}, _defineProperty({}, key, {
    description: description,
    items: [].concat(_toConsumableArray(_get(itemGroups, "".concat(key, ".items")) || []), [item])
  }));
}
export function handleArrayParentGrouping(itemGroups, item, groupByPath, defaultGroupName, groupDescriptionKey) {
  var parentValue = _get(item, getParentPath(groupByPath));
  if (_isEmpty(parentValue) || _isNil(parentValue)) {
    return defaultGroupName ? addToGroup(itemGroups, null, null, item, defaultGroupName) : itemGroups;
  }
  var lastSegment = groupByPath[groupByPath.length - 1];
  return parentValue.reduce(function (groups, subItem) {
    var subGroupValue = _get(subItem, lastSegment);
    var description = _get(subItem, groupDescriptionKey, '');
    return subGroupValue ? addToGroup(groups, subGroupValue, description, item) : groups;
  }, itemGroups);
}
export function groupItems(items, groupBy, defaultGroupName, groupDescriptionKey) {
  if (_isEmpty(items)) {
    return {};
  }
  var groupByPath = groupBy.split('.');
  return items.reduce(function (itemGroups, item) {
    if (isArrayParent(item, groupByPath)) {
      return handleArrayParentGrouping(itemGroups, item, groupByPath, defaultGroupName, groupDescriptionKey);
    }
    var groupValue = _get(item, groupBy, defaultGroupName);
    var description = _get(item, groupDescriptionKey, '');
    return groupValue ? addToGroup(itemGroups, groupValue, description, item) : itemGroups;
  }, {});
}
export function getOrderedGroups(itemGroups, defaultGroupName, orderSettings) {
  var _orderSettings$order = orderSettings.order,
    order = _orderSettings$order === void 0 ? [] : _orderSettings$order,
    _orderSettings$orderK = orderSettings.orderKey,
    orderKey = _orderSettings$orderK === void 0 ? '' : _orderSettings$orderK,
    _orderSettings$defaul = orderSettings.defaultGroupPosition,
    defaultGroupPosition = _orderSettings$defaul === void 0 ? 'last' : _orderSettings$defaul;
  var groupsWithOrder = [];
  if (_isEmpty(order)) {
    groupsWithOrder = _keys(itemGroups).filter(function (groupName) {
      return groupName !== defaultGroupName;
    }).map(function (groupName) {
      return [groupName, _get(itemGroups, "".concat(groupName, ".description")), _get(itemGroups, "".concat(groupName, ".items"))];
    });
  } else {
    groupsWithOrder = order.map(function (groupOrderConfig) {
      var groupName = _get(groupOrderConfig, orderKey, groupOrderConfig);
      var groupDescription = _get(itemGroups, "".concat(groupName, ".description"));
      var group = _get(itemGroups, "".concat(groupName, ".items"));
      if (_isEmpty(group)) {
        return null;
      }
      return groupName === defaultGroupName ? null : [groupName, groupDescription, group];
    }).filter(Boolean);
  }
  var defaultGroupConfig = [defaultGroupName, _get(itemGroups, "".concat(defaultGroupName, ".description")), _get(itemGroups, "".concat(defaultGroupName, ".items"))];
  if (defaultGroupPosition === 'start' && defaultGroupName) {
    groupsWithOrder = [defaultGroupConfig].concat(_toConsumableArray(groupsWithOrder));
  }
  if (defaultGroupPosition === 'end' && defaultGroupName) {
    groupsWithOrder = [].concat(_toConsumableArray(groupsWithOrder), [defaultGroupConfig]);
  }
  return groupsWithOrder.filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
      groupValue = _ref2[2];
    return !_isEmpty(groupValue);
  });
}
export function createContainerClassName(className) {
  var baseClasses = {
    'grouped-list': true
  };
  if (className) {
    baseClasses = _objectSpread(_objectSpread({}, baseClasses), {}, _defineProperty({}, className, true));
  }
  return classNames(baseClasses);
}
export function shouldDisplayHeader(groupName, defaultGroupName, displayDefaultGroupName) {
  if (groupName !== defaultGroupName) {
    return true;
  }
  return displayDefaultGroupName;
}
export function shouldDisplayDescription(groupName, defaultGroupName, groupDescriptionKey) {
  return !_isEmpty(groupDescriptionKey) && groupName !== defaultGroupName;
}